import Consent from "pages/LandingPages/Consent";

export default function ConsentPage() {
  return <Consent />;
}
